declare global {
    interface Window {
        // pageData: {
        //     _dwt: string;
        //     config: IPageConfig;
        // };
        // __LANG__: Record<string, Record<string, string>>;
        // BJ_REPORT: any;
        // Sentry: any;
        // langMap: Record<TLocale, TLang>;
        pageData: any;
        __LANG__: any;
        BJ_REPORT: any;
        Sentry: any;
        langMap: any;
    }
}

/** 系统类型 */
export enum SYSTEM_TYPE {
    CN = 'CN',
    JP = 'JP',
    EN = 'EN',
    TW = 'TW',
    EM = 'EM',
    ATES = 'ATES'
}
type TSystem = keyof typeof SYSTEM_TYPE;

/** 域名类型 */
export enum DOMAIN_TYPE {
    cn = 'cn',
    com = 'com',
    co = 'co',
    tw = 'tw',
    io = 'io',
    ates = 'ates'
}

export type TLang =
    | 'cn'
    | 'en'
    | 'jp'
    | 'tw'
    | 'th'
    | 'es'
    | 'ko'
    | 'fr'
    | 'id'
    | 'ru'
    | 'pt'
    | 'de'
    | 'it'
    | 'vi'
    | 'sv'
    | 'nl'
    | 'ar'
    | 'he';
export type TLocale =
    | 'zh-cn'
    | 'en-us'
    | 'ja-jp'
    | 'zh-tw'
    | 'th-th'
    | 'es-es'
    | 'ko-kr'
    | 'fr-fr'
    | 'id-id'
    | 'ru-ru'
    | 'pt-br'
    | 'de-de'
    | 'it-it'
    | 'vi-vn'
    | 'sv-se'
    | 'nl-nl'
    | 'ar-ae'
    | 'he-il';

/** 域名对应的系统 */
export const SYSTEM_DOMAIN_OF_TYPE = {
    cn: SYSTEM_TYPE.CN,
    com: SYSTEM_TYPE.EN,
    co: SYSTEM_TYPE.JP,
    tw: SYSTEM_TYPE.TW,
    io: SYSTEM_TYPE.EM,
    ates: SYSTEM_TYPE.ATES
};
type TDomain = keyof typeof DOMAIN_TYPE;

interface IPageConfig {
    env: 'pd' | 'ONLINE';
    lang: TLocale;
    system: TSystem;
}

interface IContextInfo {
    PAGE_NAME: string;
    PAGE_CONFIG: IPageConfig;
}

export const getInitialValue = (windowObj: Window = window) => {
    const context: IContextInfo = {
        PAGE_NAME: windowObj?.pageData?._dwt || '',
        PAGE_CONFIG: windowObj?.pageData?.config || {}
    };

    if (!context.PAGE_NAME || Object.keys(context.PAGE_CONFIG).length === 0) {
        console.error(new Error('Get PAGE_NAME failed, please check window.pageData'));
    }

    if (!window.langMap || Object.keys(window.langMap).length === 0) {
        console.error(new Error('Get LANG MAP failed, please check window.langMap'));
    }

    // 错误处理
    const isProd: boolean = (context.PAGE_CONFIG.env || '').toLowerCase() === 'ONLINE'.toLocaleLowerCase();
    const langVal: TLang = window.langMap?.[context.PAGE_CONFIG.lang || ''] || '';
    const systemVal: TSystem = context.PAGE_CONFIG.system || '';

    return { context, isProd, langVal, systemVal };
};

export const { context, isProd, langVal, systemVal } = getInitialValue();

export const checkIsLocalDevEnv = () => {
    const localDevHostPrefixes = ['test.', 'ntest.', 'local.', 'dev', 'm.dev', 'app.', 'sandbox.', 'm.app'];
    const windowHost = window.location.host;
    return localDevHostPrefixes.some((prefix) => windowHost.indexOf(prefix) === 0);
};

export const isLocalDevEnv = checkIsLocalDevEnv();

/**
 * 判断当前是否为对应的语言
 * @param val string
 * @returns boolean
 */
export const _lang = (val: TLang | string): boolean => {
    if (!val) {
        console.error('_lang error: need lang val');
    }

    const currentLang = getCurrentLang();
    return val.toLowerCase() === currentLang.toLowerCase();
};
// alias for _lang
export const isLang = _lang;

/**
 * 判断当前是否为对应的系统
 * @param val string
 * @returns boolean
 */
export const _system = (val: TSystem | string): boolean => {
    if (!val) {
        console.error('_system error: need system val');
    }

    const currentSystem = getCurrentSystem();
    return val.toLowerCase() === currentSystem.toLowerCase();
};
// alias for _system
export const isSystem = _system;

/**
 * 通过location.host获取对应的系统，从pageData中获取数据失败时的兜底方案
 * @returns TSystem
 */
export const getCurrentSystemUsingHost = (): TSystem => {
    const hostString = window?.location?.host;
    const hostParts = hostString.split('.');
    const hostDomain = hostParts[hostParts.length - 1] as TDomain;
    const systemVal = SYSTEM_DOMAIN_OF_TYPE[hostDomain] || '';

    return systemVal;
};

export const getCurrentLang = (): TLang => {
    return langVal;
};

export const getCurrentSystem = (): TSystem => {
    if (systemVal) {
        return systemVal;
    }

    return getCurrentSystemUsingHost();
};

/**
 * 初始化在body上添加class环境信息
 */
export const initBodyClassName = () => {
    document.body.classList.add(`locale-${getCurrentLang().toLowerCase()}`);
    document.body.classList.add(`system-${getCurrentSystem().toLowerCase()}`);
    // 给阿拉伯语和希伯来语添加rtl的class
    if (getCurrentLang().toLowerCase() === 'ar' || getCurrentLang().toLowerCase() === 'he') {
        const root = document.documentElement;
        if (root.className.indexOf('display-rtl') === -1) {
            root.className += ' display-rtl';
        }
    }
};

//--------------------------------- utils end ------------------------------

const COMMON_NAMESPACE = 'web_common';

export const lang = (key: string, ...args: any[]) => getLang(key, getContent(key), ...args);
/**
 * 获取公用语言，当前使用和lang相同的实现
 */
export const commonLang = lang;

/**
 *
 * @param key
 * @param _
 * @param args
 * @returns
 */
export const dupLang = (key: string, _: string, ...args: string[]) => getLang(key, getContent(key), ...args);

/**
 * lang方法的别名函数->t,
 */
export const t = lang;

export const generateLang = (namespace: string) => ({
    lang: (key: string, ...args: string[]) => getLang(key, getContent(key, namespace), ...args),
    commonLang: (key: string, ...args: string[]) => getLang(key, getContent(key, namespace), ...args),
    dupLang: (key: string, _: string, ...args: string[]) => getLang(key, getContent(key, namespace), ...args)
});

/** 站点配置检查替换 */
const SITE_CONFIG_KEYS = {
    EMAIL: /(support@umu.com|cs@umu.co)/g
};
/** 根据站点替换显示邮箱 */
const getLangWithSystem = (value: string) => {
    if (typeof value !== 'string') {
        return value;
    }
    if (isSystem('jp')) {
        return value.replace(SITE_CONFIG_KEYS.EMAIL, 'support@umu.co');
    }
    return value;
};

/**
 * 注册当前语言获取方法的命名空间
 * @param key 命名空间
 */
export const registerConfig = (key: string) => {
    context.PAGE_NAME = key;
};

/**
 * 数据层级
 * 第一级：语言
 */
export const getContent = (langKey: string, namespace?: string, windowObj = window) => {
    // 直接读取pageName作为第二个命名空间，node下发的
    const pageName = namespace || context.PAGE_NAME;

    const LANG_CONTENT_ALL = windowObj.__LANG__;
    const LANG_CONTENT = LANG_CONTENT_ALL?.[pageName];
    const COMMON_LANG_CONTENT = LANG_CONTENT_ALL?.[COMMON_NAMESPACE];
    /**
     * 去除了 COMMON_LANG_CONTENT 的判断，因为 pc 在使用 ukit-lang 时，文档页面是没有 web_common的
     */
    if (!pageName || !LANG_CONTENT_ALL || !LANG_CONTENT) {
        // 无法获取语言文件，视为CDN加载失败的情况
        reportError(pageName, 'cdn_fail', 'cdn_fail');
        return {};
    }

    // 优先寻找dwt命名空间下的多语，如果没有的话，则找web_common命名空间
    if (typeof LANG_CONTENT[langKey] !== 'undefined') {
        return LANG_CONTENT;
    }

    return COMMON_LANG_CONTENT || {};
};

function getValueWithLocal(value: string, key: string) {
    if (isLocalDevEnv) {
        // 本地开发环境下，如果没有对应的langValue，使用默认的key为结果
        if (typeof value === 'undefined') {
            return key;
        }
    }
    return value;
}

/**
 * 多语文案替换
 *
 * 多语文案内容，全部放到$window.content下面取
 *
 * @param key 多语key
 * @param content 内容
 * @param args 多语的参数
 */
export const getLang = (key: string, content: Record<string, string>, ...args: any[]): any => {
    if (Object.keys(content).length === 0) {
        return getLangWithSystem(key);
    }

    let value = '';
    try {
        if (args.length > 0) {
            /**
             * 有参数，先匹配出${}
             * idx 表示序号
             */
            let originLangValue = content[key] || '';
            if (originLangValue === '') {
                reportError(context.PAGE_NAME, key, 'lang');
            }

            // 在本地开发环境下，如果没有对应的langValue，使用默认的key为结果
            if (isLocalDevEnv && originLangValue === '') {
                originLangValue = key;
            }

            value = replaceWithArgs(originLangValue, args);
        } else {
            /**
             * 没有参数，直接匹配
             */
            value = content[key];
            if (value === undefined) {
                reportError(context.PAGE_NAME, key, 'lang');
            }
        }
        value = getValueWithLocal(value, key);
        return getLangWithSystem(value);
    } catch (err) {
        reportError(context.PAGE_NAME, key, 'lang');
        return getLangWithSystem(key);
    }
};

// 替换变量的内部方法
function replaceWithArgs(value: string, args: any[]): string {
    return value.replace(
        /\{(\$\$?)(\d+)(\{(.*?)\})?\}/g,
        (
            _: string,
            variableDelimiter: string, // 匹配变量 $,$$
            idx: number, // 匹配序号数字
            fullPlurals: string, // {0=xx,1=xx} 单复数处理
            plurals: string
        ) => {
            /**
             * 单复数情况
             * $$ ?待验证
             */
            if (fullPlurals) {
                const arr = plurals.split(',');
                let singleTxt: string;
                let otherTxt: string;
                let result = `${args[idx]}`;
                for (const pluralSegment of arr) {
                    if (pluralSegment.indexOf('1=') === 0) {
                        singleTxt = pluralSegment.replace('1=', '');
                    } else {
                        otherTxt = pluralSegment.split('=')[1];
                    }
                }

                result = result.replace(/[\w|\.]+/g, (word: string) => {
                    return variableDelimiter === '$$'
                        ? word === '1'
                            ? singleTxt
                            : otherTxt
                        : `${word}${word === '1' ? singleTxt : otherTxt}`;
                });
                return result;
            }
            return args[idx];
        }
    );
}

/**
 * 当 umu-design 等项目需要使用多语时，主要是处理变量时，需要使用到 ukit-lang
 * 但 ukit-lang 需要依赖 window 的很多变量，所以这里只暴露一个 langReplace 方法
 */
export const langReplace = (value: string, ...args: any[]): any => {
    if (args.length === 0) {
        return value;
    }
    return replaceWithArgs(value, args);
};

class I18nError extends Error {
    static __proto__: ErrorConstructor;

    constructor(msg: string) {
        super(msg);
        this.name = 'I18nError';
        // 为了图片截图中PhantomJS中JS不支持Object.setPrototypeOf语法的问题，相关Slack链接：https://umu-cn.slack.com/archives/C02U38XAH3N/p1653362894445059
        if (Object.setPrototypeOf) {
            Object.setPrototypeOf(this, I18nError.prototype);
        } else {
            I18nError.__proto__ = Error;
        }
    }
}

/**
 * 缓存，如果发送过，不再发送
 */
const sendedErrors: string[] = [];

function reportError(scope: string, key: string, type: string) {
    // 本地开发环境下，不进行错误的上报和log处理
    if (isLocalDevEnv) {
        return;
    }

    const location = window.location.href;
    const errObj: Record<string, string> = {
        scope: scope,
        key: key,
        type: type,
        lang: langVal
    };

    const errString = JSON.stringify(errObj);
    // 判断是否发送过，如果已经缓存过，不进行后续上报处理
    if (sendedErrors.indexOf(errString) > -1) {
        return;
    }

    // 缓存已发送的错误信息
    sendedErrors.push(errString);

    errObj.loc = location;
    const errStr = `i18n_err:${JSON.stringify(errObj)}`;

    console.log(new I18nError(errStr));

    if (window.Sentry?.captureException) {
        const i18nError = new I18nError(JSON.stringify(errObj));
        window.Sentry.captureException(i18nError);
        return;
    }
}
